<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  components: { ContentLoader },
  props: {
    primaryColor: {
      type: String,
      default: '#F9FAFF',
    },
    secondaryColor: {
      type: String,
      default: '#D8DFF6',
    },
  },
};
</script>

<template>
  <content-loader
    width="1276"
    height="243"
    viewBox="0 0 1276 243"
    :speed="2"
    :primaryColor="primaryColor"
    :secondaryColor="secondaryColor"
    :primaryOpacity="0.9"
    :secondaryOpacity="0.25"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M438.944 87.5H546.999V92.5H440.055L301.759 157.106L210.45 134.65L115.356 196.1L112.643 191.9L209.549 129.28L301.24 151.83L438.944 87.5Z"
      fill="#C4C4C4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M111.633 119.093L114.365 114.906L208.636 176.43L299.099 168.016L438.427 135.725L544.425 154.046L543.573 158.973L438.571 140.824L299.899 172.964L207.363 181.57L111.633 119.093Z"
      fill="#C4C4C4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M547.582 28.9356L437.724 118.74L304.765 84.0989L202.426 67.7907L113.451 84.1081L112.549 79.1902L202.367 62.7182L305.791 79.1994L436.527 113.261L544.418 25.0645L547.582 28.9356Z"
      fill="#C4C4C4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M206.685 195.5H439.807L538.377 210.529L537.623 215.471L439.428 200.5H207.104L118.416 215.465L117.584 210.535L206.685 195.5Z"
      fill="#C4C4C4"
    />
    <circle cx="202" cy="65" r="5" fill="#C4C4C4" />
    <circle cx="210" cy="132" r="5" fill="#C4C4C4" />
    <circle cx="207" cy="198" r="5" fill="#C4C4C4" />
    <circle cx="302" cy="154" r="5" fill="#C4C4C4" />
    <circle cx="302" cy="81" r="5" fill="#C4C4C4" />
    <circle cx="302" cy="170" r="5" fill="#C4C4C4" />
    <circle cx="302" cy="196" r="5" fill="#C4C4C4" />
    <circle cx="438" cy="89" r="5" fill="#C4C4C4" />
    <circle cx="438" cy="114" r="5" fill="#C4C4C4" />
    <circle cx="438" cy="197" r="5" fill="#C4C4C4" />
    <circle cx="546" cy="26" r="5" fill="#C4C4C4" />
    <circle cx="546" cy="89" r="5" fill="#C4C4C4" />
    <circle cx="546" cy="156" r="5" fill="#C4C4C4" />
    <circle cx="541" cy="213" r="5" fill="#C4C4C4" />
    <circle cx="438" cy="138" r="5" fill="#C4C4C4" />
    <circle cx="208" cy="177" r="5" fill="#C4C4C4" />
    <rect x="697" y="31" width="42" height="22" rx="4" fill="#C4C4C4" />
    <rect x="755" y="31" width="448" height="22" rx="4" fill="#C4C4C4" />
    <rect x="697" y="71" width="42" height="22" rx="4" fill="#C4C4C4" />
    <rect x="755" y="71" width="248" height="22" rx="4" fill="#C4C4C4" />
    <rect x="697" y="110" width="42" height="23" rx="4" fill="#C4C4C4" />
    <rect x="755" y="110" width="222" height="23" rx="4" fill="#C4C4C4" />
    <rect x="697" y="150" width="42" height="22" rx="4" fill="#C4C4C4" />
    <rect x="755" y="150" width="104" height="22" rx="4" fill="#C4C4C4" />
    <rect x="697" y="190" width="42" height="22" rx="4" fill="#C4C4C4" />
    <rect x="755" y="190" width="95" height="22" rx="4" fill="#C4C4C4" />
  </content-loader>
</template>
